export default __webpack_public_path__ + "static/ceinture2.inspirations-00a7057d35d85251d0380a57c0784113.jpg";